import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const LogoGrid = () => {
    const sliders = document.querySelectorAll('.logo-grid__swiper');

    if (!sliders.length) return;

    sliders.forEach((slider) => {
        if (!(slider instanceof Element)) return;

        const swiperWrapper = slider.querySelector('.logo-grid__swiper-wrapper');
        if (!swiperWrapper) return;

        new Swiper(slider, {
            slidesPerView: 'auto',
            spaceBetween: 10,
            loop: true,
            speed: 4000,
            allowTouchMove: false,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            breakpoints: {
                769: { slidesPerView: 4 },
                1024: { slidesPerView: 5 },
            },
        });
    });
};

export default LogoGrid;
